import { render, Suspense } from "@wordpress/element";
import withAppProviders from "withAppProviders";
import Block from "./Block";

const OrdersFrontend = ({ attributes }) => {
	return <Block attributes={attributes} />;
};

const Orders = withAppProviders(OrdersFrontend)();

window.addEventListener("DOMContentLoaded", () => {
	const element = document.querySelector(".wp-block-vino-orders");
	if (element) {
		render(
			<Suspense fallback={<div className="wp-block-placeholder" />}>
				<Orders />
			</Suspense>,
			element
		);
	}
});
